(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-antes-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dermova-before-after')) {
    customElements.define('dermova-before-after', class extends HTMLElement {
      connectedCallback() {
        if (this.controller || this.startFrame) return;
        this.startFrame = requestAnimationFrame(() => {
          this.startFrame = null;
          if (this.isConnected) this.initialize();
        });
      }
      initialize() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.speed = Math.max(10, Math.min(120, Number(this.dataset.vel) || 40));
        this.button = this.querySelector('[data-sm-am-pause]');
        this.previousButton = this.querySelector('[data-sm-am-prev]');
        this.nextButton = this.querySelector('[data-sm-am-next]');
        this.rows = Array.from(this.querySelectorAll('[data-sm-am-fila]'), el => ({
          el, group: el.querySelector('[data-sm-am-original]'), viewport: el.parentElement,
          phase: 0, period: 0, right: el.dataset.dir === 'derecha'
        }));
        if (!this.rows.length) return;
        this.setPaused(false);
        this.hovered = false;
        this.focused = this.contains(document.activeElement);
        this.visible = true;
        this.tick = this.tick.bind(this);
        this.button.addEventListener('click', () => {
          this.setPaused(!this.userPaused);
          this.sync();
        }, { signal });
        this.previousButton.addEventListener('click', () => this.navigate(-1), { signal });
        this.nextButton.addEventListener('click', () => this.navigate(1), { signal });
        this.rows.forEach(row => {
          row.viewport.addEventListener('scroll', () => this.updateControls(), { signal, passive: true });
          row.viewport.addEventListener('keydown', event => {
            if (event.target !== row.viewport || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
            event.preventDefault();
            this.navigate(event.key === 'ArrowRight' ? 1 : -1);
          }, { signal });
        });
        this.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch' && this.dataset.pausa === '1') { this.hovered = true; this.sync(); } }, { signal });
        this.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); }, { signal });
        this.addEventListener('focusin', () => { this.focused = true; this.sync(); }, { signal });
        this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.sync(); }, { signal });
        document.addEventListener('visibilitychange', () => this.sync(), { signal });
        this.motion.addEventListener('change', () => this.measure(), { signal });
        this.resize = new ResizeObserver(() => this.measure());
        this.resize.observe(this);
        this.rows.forEach(row => this.resize.observe(row.group));
        this.intersection = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); });
        this.intersection.observe(this);
        this.measure();
      }
      measure() {
        this.stop();
        const reduced = this.motion.matches;
        this.toggleAttribute('data-animated', !reduced);
        this.button.hidden = reduced;
        this.rows.forEach(row => {
          row.el.querySelectorAll('[data-sm-am-clone]').forEach(clone => clone.remove());
          const previous = row.period;
          row.period = row.group.getBoundingClientRect().width;
          row.phase = previous ? row.phase / previous * row.period : 0;
          if (this.reduced && !reduced && row.period) {
            row.phase = (row.right ? row.period - row.viewport.scrollLeft : row.viewport.scrollLeft) % row.period;
          }
          if (reduced || !row.period) {
            row.el.style.removeProperty('transform');
            if (reduced && this.reduced === false && row.period) {
              row.viewport.scrollLeft = (row.right ? row.period - row.phase : row.phase) % row.period;
            }
            return;
          }
          row.viewport.scrollLeft = 0;
          const copies = Math.ceil(row.viewport.clientWidth / row.period) + 1;
          for (let i = 0; i < copies; i++) {
            const clone = row.group.cloneNode(true);
            clone.removeAttribute('data-sm-am-original');
            clone.setAttribute('data-sm-am-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('inert', '');
            [clone, ...clone.querySelectorAll('*')].forEach(node => {
              node.removeAttribute('id');
              node.removeAttribute('data-shopify-editor-block');
              node.removeAttribute('data-shopify-editor-section');
            });
            clone.querySelectorAll('img').forEach(img => { img.alt = ''; });
            row.el.append(clone);
          }
          this.paint(row);
        });
        this.reduced = reduced;
        this.updateControls();
        this.sync();
      }
      setPaused(paused) {
        this.userPaused = paused;
        this.toggleAttribute('data-user-paused', paused);
        this.button.querySelector('[data-sm-am-label]').textContent = paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel;
      }
      navigate(direction) {
        this.setPaused(true);
        this.stop();
        this.rows.forEach(row => {
          const count = row.group.children.length;
          if (count < 2 || !row.period) return;
          const step = row.period / count;
          if (this.motion.matches) {
            const max = Math.max(0, row.viewport.scrollWidth - row.viewport.clientWidth);
            row.viewport.scrollLeft = Math.max(0, Math.min(max, row.viewport.scrollLeft + direction * step));
          } else {
            row.phase = (row.phase + direction * step * (row.right ? -1 : 1) + row.period) % row.period;
            this.paint(row);
          }
        });
        this.updateControls();
      }
      updateControls() {
        const canMove = direction => this.rows.some(row => {
          if (row.group.children.length < 2 || !row.period) return false;
          if (!this.motion.matches) return true;
          const max = Math.max(0, row.viewport.scrollWidth - row.viewport.clientWidth);
          return direction < 0 ? row.viewport.scrollLeft > 1 : row.viewport.scrollLeft < max - 1;
        });
        this.previousButton.disabled = !canMove(-1);
        this.nextButton.disabled = !canMove(1);
      }
      paint(row) {
        const x = row.right ? row.phase - row.period : -row.phase;
        row.el.style.transform = 'translate3d(' + x.toFixed(3) + 'px,0,0)';
      }
      stop() {
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.last = null;
      }
      sync() {
        this.stop();
        if (!this.isConnected || !this.rows.length || this.motion.matches || this.userPaused || this.hovered || this.focused || document.hidden || !this.visible) return;
        this.frame = requestAnimationFrame(this.tick);
      }
      tick(time) {
        const delta = this.last === null ? 0 : Math.min((time - this.last) / 1000, .05);
        this.last = time;
        this.rows.forEach(row => {
          if (!row.period) return;
          row.phase = (row.phase + this.speed * delta) % row.period;
          this.paint(row);
        });
        this.frame = requestAnimationFrame(this.tick);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame);
        this.startFrame = null;
        this.stop();
        this.controller?.abort();
        this.resize?.disconnect();
        this.intersection?.disconnect();
        this.reduced = undefined;
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
